import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
// (c) 2018 Philippe Riviere
//
// https://github.com/Fil/
//
// This software is distributed under the terms of the MIT License
import { extent } from "d3-array";
import { geoCentroid, geoDistance } from "d3-geo";
import { geoDelaunay, excess } from "./delaunay.js";
import { tau } from "./math.js";
export function geoVoronoi(data) {
  var v = function v(data) {
    v.delaunay = null;
    v._data = data;

    if (typeof v._data === "object" && v._data.type === "FeatureCollection") {
      v._data = v._data.features;
    }

    if (typeof v._data === "object") {
      var temp = v._data.map(function (d) {
        return [v._vx(d), v._vy(d), d];
      }).filter(function (d) {
        return isFinite(d[0] + d[1]);
      });

      v.points = temp.map(function (d) {
        return [d[0], d[1]];
      });
      v.valid = temp.map(function (d) {
        return d[2];
      });
      v.delaunay = geoDelaunay(v.points);
    }

    return v;
  };

  v._vx = function (d) {
    if (typeof d == "object" && "type" in d) {
      return geoCentroid(d)[0];
    }

    if (0 in d) return d[0];
  };

  v._vy = function (d) {
    if (typeof d == "object" && "type" in d) {
      return geoCentroid(d)[1];
    }

    if (1 in d) return d[1];
  };

  v.x = function (f) {
    if (!f) return v._vx;
    v._vx = f;
    return v;
  };

  v.y = function (f) {
    if (!f) return v._vy;
    v._vy = f;
    return v;
  };

  v.polygons = function (data) {
    if (data !== undefined) {
      v(data);
    }

    if (!v.delaunay) return false;
    var coll = {
      type: "FeatureCollection",
      features: []
    };
    if (v.valid.length === 0) return coll;
    v.delaunay.polygons.forEach(function (poly, i) {
      return coll.features.push({
        type: "Feature",
        geometry: !poly ? null : {
          type: "Polygon",
          coordinates: [[].concat(_toConsumableArray(poly), [poly[0]]).map(function (i) {
            return v.delaunay.centers[i];
          })]
        },
        properties: {
          site: v.valid[i],
          sitecoordinates: v.points[i],
          neighbours: v.delaunay.neighbors[i] // not part of the public API

        }
      });
    });
    if (v.valid.length === 1) coll.features.push({
      type: "Feature",
      geometry: {
        type: "Sphere"
      },
      properties: {
        site: v.valid[0],
        sitecoordinates: v.points[0],
        neighbours: []
      }
    });
    return coll;
  };

  v.triangles = function (data) {
    if (data !== undefined) {
      v(data);
    }

    if (!v.delaunay) return false;
    return {
      type: "FeatureCollection",
      features: v.delaunay.triangles.map(function (tri, index) {
        tri = tri.map(function (i) {
          return v.points[i];
        });
        tri.center = v.delaunay.centers[index];
        return tri;
      }).filter(function (tri) {
        return excess(tri) > 0;
      }).map(function (tri) {
        return {
          type: "Feature",
          properties: {
            circumcenter: tri.center
          },
          geometry: {
            type: "Polygon",
            coordinates: [[].concat(_toConsumableArray(tri), [tri[0]])]
          }
        };
      })
    };
  };

  v.links = function (data) {
    if (data !== undefined) {
      v(data);
    }

    if (!v.delaunay) return false;

    var _distances = v.delaunay.edges.map(function (e) {
      return geoDistance(v.points[e[0]], v.points[e[1]]);
    }),
        _urquart = v.delaunay.urquhart(_distances);

    return {
      type: "FeatureCollection",
      features: v.delaunay.edges.map(function (e, i) {
        return {
          type: "Feature",
          properties: {
            source: v.valid[e[0]],
            target: v.valid[e[1]],
            length: _distances[i],
            urquhart: !!_urquart[i]
          },
          geometry: {
            type: "LineString",
            coordinates: [v.points[e[0]], v.points[e[1]]]
          }
        };
      })
    };
  };

  v.mesh = function (data) {
    if (data !== undefined) {
      v(data);
    }

    if (!v.delaunay) return false;
    return {
      type: "MultiLineString",
      coordinates: v.delaunay.edges.map(function (e) {
        return [v.points[e[0]], v.points[e[1]]];
      })
    };
  };

  v.cellMesh = function (data) {
    if (data !== undefined) {
      v(data);
    }

    if (!v.delaunay) return false;
    var _v$delaunay = v.delaunay,
        centers = _v$delaunay.centers,
        polygons = _v$delaunay.polygons;
    var coordinates = [];

    var _iterator = _createForOfIteratorHelper(polygons),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var p = _step.value;
        if (!p) continue;

        for (var n = p.length, p0 = p[n - 1], p1 = p[0], i = 0; i < n; p0 = p1, p1 = p[++i]) {
          if (p1 > p0) {
            coordinates.push([centers[p0], centers[p1]]);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return {
      type: "MultiLineString",
      coordinates: coordinates
    };
  };

  v._found = undefined;

  v.find = function (x, y, radius) {
    v._found = v.delaunay.find(x, y, v._found);
    if (!radius || geoDistance([x, y], v.points[v._found]) < radius) return v._found;
  };

  v.hull = function (data) {
    if (data !== undefined) {
      v(data);
    }

    var hull = v.delaunay.hull,
        points = v.points;
    return hull.length === 0 ? null : {
      type: "Polygon",
      coordinates: [[].concat(_toConsumableArray(hull.map(function (i) {
        return points[i];
      })), [points[hull[0]]])]
    };
  };

  return data ? v(data) : v;
}